import { useEffect } from "react";
import { useLocation } from "react-router";
import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-QX886NM8ZZ";

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }, []);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
}
